"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _ThemeHelper = require("../Utilities/ThemeHelper");

var useStyles = (0, _ThemeHelper.makeStyles)(function (theme) {
  return {
    root: {
      // Fixes for JSS specificity issue https://civicplus.tpondemand.com/entity/89077
      "& label[data-shrink=false] + .prmbl-textInput-input > input[placeholder]::-webkit-input-placeholder": {
        opacity: 0
      },
      "& label[data-shrink=false] + .prmbl-textInput-input > input[placeholder]::-moz-placeholder": {
        opacity: 0
      },
      "& label[data-shrink=false] + .prmbl-textInput-input > input[placeholder]:-ms-input-placeholder": {
        opacity: 0
      },
      "& label[data-shrink=false] + .prmbl-textInput-input > input[placeholder]::-ms-input-placeholder": {
        opacity: 0
      }
    },
    outlinedLabelReadOnly: {
      cursor: "default"
    },
    outlinedLabel: {
      cursor: "text",
      paddingRight: 1.5,
      transform: "translate(14px, 125%)",
      whiteSpace: "nowrap",
      zIndex: 3,
      pointerEvents: "none"
    },
    outlinedShrunkLabel: {
      cursor: "pointer",
      fontWeight: "bold",
      color: theme.palette.primary.main
    },
    outlinedWrapper: {
      "& fieldset": {
        borderRadius: 2,
        borderWidth: 1
      },
      // This is gross and may cause issues with disabled fields, but jss sucks so here we are.
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main + " !important"
      }
    },
    outlinedInput: {
      background: theme.palette.background.blurred,
      transition: theme.transitions.create("background"),
      "&:focus-within": {
        background: theme.palette.background.paper
      },
      borderRadius: 2,
      "& > input": {
        height: "auto"
      }
    },
    filledLabel: {},
    filledLabelReadOnly: {},
    filledShrunkLabel: {},
    filledWrapper: {},
    filledInput: {},
    standardLabel: {},
    standardLabelReadOnly: {},
    standardShrunkLabel: {},
    standardWrapper: {},
    standardInput: {},
    compactLabelReadOnly: {
      cursor: "default"
    },
    compactLabel: {
      cursor: "text",
      paddingRight: 1.5,
      transform: "translate(14px, 72%)",
      whiteSpace: "nowrap",
      zIndex: 3,
      pointerEvents: "none"
    },
    compactShrunkLabel: {
      cursor: "pointer",
      fontWeight: "bold",
      color: theme.palette.primary.main
    },
    compactWrapper: {
      "& fieldset": {
        borderRadius: 2,
        borderWidth: 1
      },
      // This is gross and may cause issues with disabled fields, but jss sucks so here we are.
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main + " !important"
      }
    },
    compactInput: {
      transition: "background " + theme.transitions.easing.easeInOut + " " + theme.transitions.duration.standard + "ms, padding " + theme.transitions.easing.easeInOut + " " + theme.transitions.duration.shorter + "ms",
      "&:focus-within": {
        background: theme.palette.background.paper
      },
      borderRadius: 2,
      paddingRight: "0px !important"
    },
    compactInputElement: {
      padding: 9,
      transition: theme.transitions.create("padding", {
        duration: theme.transitions.duration.shorter
      }),
      "& .prmbl-autocomplete__value-container": {
        padding: theme.spacing(0.25)
      },
      "& .prmbl-autocomplete__dropdown-indicator": {
        padding: 0,
        paddingRight: theme.spacing(0.25)
      },
      "& .prmbl-autocomplete__single-value": {
        width: "100%"
      }
    },
    customComponent: {
      cursor: "inherit"
    },
    buttonTooltipFix: {
      borderRadius: "50%",
      margin: theme.spacing(-1.5),
      padding: theme.spacing(1.5),
      display: "inherit"
    },
    error: {
      margin: 0,
      "& > .prmbl-textInput-input > fieldset": {
        borderColor: "".concat(theme.palette.error.dark, " !important")
      }
    },
    errorMessageWrapper: {
      display: "flex",
      flexGrow: 1,
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "center",
      margin: 0,
      padding: theme.spacing(1),
      paddingRight: theme.spacing(1.5),
      background: theme.palette.error.dark,
      color: theme.palette.background.paper,
      fontWeight: "bold",
      borderRadius: "0 0 ".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px")
    },
    errorIcon: {
      marginRight: theme.spacing(0.5)
    },
    datePickerWrapper: {
      background: theme.palette.background.paper,
      overflow: "hidden"
    },
    timePickerWrapper: {},
    helperText: {
      marginLeft: 0,
      marginRight: 0,
      display: "flex",
      alignItems: "center"
    }
  };
});
exports.useStyles = useStyles;